@if (type() === 'avatar') {
  <img src="/assets/alice/avatar.svg" alt="Alice avatar" />
} @else if (type() === 'static') {
  <img src="/assets/alice/static.svg" alt="Alice image" [width]="width()" [height]="height()" />
} @else if (type() === 'animation') {
  <ng-lottie #component [options]="defaultOptions"></ng-lottie>
  <ng-lottie #component (complete)="complete()" [options]="options"></ng-lottie>
}
